<script setup lang="ts">
import { THEME } from "@pkg/config/misc/theme";
import { computed, type Component } from "vue";
import { BagVariant } from "@pkg/sanity-utils/types/bag";

interface SubBlock {
  _type: string;
  _key: string;
  title?: string;
  icon?: string;
}

const props = defineProps<{
  block?: {
    _type: string;
    _key: string;
    theme?: THEME;
    anchorId?: string;
    variant: BagVariant;
    title?: {
      preTitle?: string;
      title?: string;
    };
    upperLeftBlock?: SubBlock;
    upperRightBlock?: SubBlock;
    lowerLeftBlock?: SubBlock;
    lowerRightBlock?: SubBlock;
  };
  config: {
    innerComponent?: Component;
  };
}>();

const data = computed(() => ({
  variant: props.block?.variant,
  title: props.block?.title,
  upperLeftBlock: props.block?.upperLeftBlock,
  upperRightBlock: props.block?.upperRightBlock,
  lowerLeftBlock: props.block?.lowerLeftBlock,
  lowerRightBlock: props.block?.lowerRightBlock,
  theme: props.block?.theme ?? THEME.LIGHT,
}));
</script>

<template>
  <component :is="props.config?.innerComponent" :id="props.block?.anchorId" v-bind="data" />
</template>
